import { LoginRule } from './LoginRule'
import { ReadyRule } from './ReadyRule.js'
import { LogoutRule } from './LogoutRule.js'
import { DialogRule } from './DialogRule.js'
import { CalloutRule } from './CalloutRule.js'
import { NotReadyRule } from './NotReadyRule.js'
import { ProblemRule } from './ProblemRule.js'
import { WrapupRule } from './WrapupRule.js'
import { AssistedRule } from './AssistedRule.js'
import { OtherRule } from './OtherRule.js'
import { FistCallRule } from './FirstCall'
import { AuxiliarRule } from './AuxiliaryRule.js'

export const MainRule = {
  "Login": LoginRule,
  "Ready": ReadyRule,
  "logout": LogoutRule,
  "Dialog": DialogRule,
  "Callout": CalloutRule,
  "NotReady": NotReadyRule,
  "Problem": ProblemRule,
  "Wrapup": WrapupRule,
  "Other": OtherRule,
  "TransferAgent": OtherRule,
  "Assisted":AssistedRule,
  "firstCall":FistCallRule,
  "Auxiliary": AuxiliarRule,
}


// WEBPACK FOOTER //
// ./src/BusinessRule/MainRule.js